"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/ve_banner.css.ts
var ve_banner_css_exports = {};
__export(ve_banner_css_exports, {
  badge: () => badge,
  banner: () => banner,
  detail: () => detail
});
var import_fileScope = require("@vanilla-extract/css/fileScope");
var import_css = require("@vanilla-extract/css");
(0, import_fileScope.setFileScope)("src/components/ve_banner.css.ts", "css-jsx-app");
var banner = (0, import_css.style)({
  display: "inline-flex",
  alignItems: "center",
  gap: "0.6rem",
  padding: "0.55rem 0.9rem",
  borderRadius: "999px",
  background: "linear-gradient(135deg, rgba(15, 23, 42, 0.85), #0b1220)",
  border: "1px solid rgba(16, 185, 129, 0.35)",
  boxShadow: "0 12px 24px rgba(5, 10, 20, 0.4)"
});
var badge = (0, import_css.style)({
  padding: "0.35rem 0.7rem",
  borderRadius: "999px",
  background: "#10b981",
  color: "#022c22",
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  fontSize: "0.75rem"
});
var detail = (0, import_css.style)({
  color: "#cbd5e1",
  fontSize: "0.85rem"
});
(0, import_fileScope.endFileScope)();
// Annotate the CommonJS export names for ESM import in node:

export { badge, banner, detail };


export const knightedCss = ".qwp9p40{background:linear-gradient(135deg,#0f172ad9,#0b1220);border:1px solid #10b98159;border-radius:999px;align-items:center;gap:.6rem;padding:.55rem .9rem;display:inline-flex;box-shadow:0 12px 24px #050a1466}.qwp9p41{color:#022c22;letter-spacing:.06em;text-transform:uppercase;background:#10b981;border-radius:999px;padding:.35rem .7rem;font-size:.75rem;font-weight:700}.qwp9p42{color:#cbd5e1;font-size:.85rem}";
